<template>
  <div class="PersonalCenter">

    <Head :lanshow="ActiveName" :title="$tc('header.back')" />
    <!-- <NavBar /> -->
    <h5 class="mianbaoxie">
      <span>当前位置：</span><span>首页</span><span> > </span><span>个人中心</span>
    </h5>
    <div class="PersonalCenter-center">
      <div>
        <div class="title">
          <div class="text">个人资料</div>
          <div class="line" />
        </div>
        <div class="personal_info personal_info">
          <van-form ref="formRef" @submit="onSubmit" style="font-size: 3vw">
            <!-- 头像 -->
            <div class="user_img">
              <van-image :src="formList.avatar" v-model="formList.avatar" />
            </div>
            <!-- 账号 -->
            <van-cell-group class="form_filed">
              <div class="label"><span>账号</span></div>

              <van-field disabled v-model="formList.username" name="账号" placeholder="支持中英文、数字，不超过10个字" :rules="[{ required: true, message: '必填' }]">
                <template #button>
                  <span class="form_filed_handle" v-if="accountUpdatable" @click="ModifyAccountNumber">修改></span>
                </template>
              </van-field>
            </van-cell-group>
            <!-- 密码 -->
            <van-cell-group class="form_filed">
              <div class="label"><span></span><span>密码</span></div>
              <van-field disabled v-model="formList.password" type="password" name="密码" placeholder="请输入8位密码，支持英文、数字" :rules="[{ required: true, message: '必填' }]">
                <template #button>
                  <span class="form_filed_handle" @click="ChangePassword">修改></span>
                </template>
              </van-field>
            </van-cell-group>
            <!-- 手机号 -->
            <van-cell-group class="form_filed" v-if="!(kind == 0)">
              <div class="label"><span>手机号</span></div>

              <van-field v-model="formList.phone" name="手机号" placeholder="请输入11位手机号" maxlength="11" disabled :rules="[{ required: true, message: '请填写手机号' },{ pattern: /^\d{11}$/, message: '格式不正确' }]" />
            </van-cell-group>
            <!-- 昵称 -->
            <van-cell-group class="form_filed" v-else>
              <div class="label"><span>昵称</span></div>

              <van-field v-model="formList.nickname" name="昵称" placeholder="支持中英文、数字，不超过10个字" maxlength="10" :rules="[{ required: true, message: '必填' },{ pattern: /^[A-Za-z0-9\u4E00-\u9FA5]+$/, message: '格式不正确' }]" />
            </van-cell-group>
            <!-- 姓名 -->
            <van-cell-group class="form_filed">
              <div class="label"><span>姓名（真实姓名）</span></div>
              <van-field class="input_box" v-model="formList.name" name="姓名" placeholder="支持中英文、数字，不超过10个字" maxlength="10" :rules="[{ required: true, message: '必填' },{ pattern: /^[A-Za-z0-9\u4E00-\u9FA5]+$/, message: '格式不正确' }]" />
            </van-cell-group>
            <!-- 我的身份 -->
            <van-cell-group class="form_filed">
              <div class="label"><span>我的身份</span></div>
              <van-field disabled v-model="formList.wodeshenfen" name="身份" />
            </van-cell-group>
            <van-cell-group class="form_filed" v-if="formList.wodeshenfen == '网民'">
              <div class="authentication">
                <span v-if="kind == 0 && (formListStatus !==0 || (formListStatus === 0 && oldForm.kind === 1))" @click="toAuthentication()">认证成为义务监督员></span>
                <span v-if="kind == 0 && (formListStatus !==0 || (formListStatus === 0 && oldForm.kind === 2))" @click="toVolunteerCertification()">认证成为志愿者></span>
              </div>
            </van-cell-group>
            <!-- 我的性别 -->
            <van-cell-group class="form_filed">
              <div class="label"><span>性别</span></div>
              <div class="van-cell van-field noBorder" :aria-disabled="true">
                <div class="van-cell__value van-field__value">
                  <div class="van-field__body">
                    <div class="sexSelectBox" native-type="button" :class="formList.gender == 0 && 'sexSelected'" @click="formList.gender = 0">
                      男
                    </div>
                    <div class="sexSelectBox" native-type="button" :class="formList.gender == 1 && 'sexSelected'" @click="formList.gender = 1">
                      女
                    </div>
                  </div>
                </div>
              </div>
            </van-cell-group>

            <!-- 电子邮箱 -->
            <van-cell-group class="form_filed">
              <div class="label"><span>电子邮箱</span></div>
              <van-field class="input_box" type="text" v-model="formList.email" placeholder="请输入正确邮箱" maxlength="50" :rules="[
                  { required: true, message: '必填' },
                  {
                    pattern:
                      /@/,
                    message: '电子邮箱格式错误',
                  },
                ]" />
            </van-cell-group>
            <!-- 所处地域 -->
            <van-cell-group class="form_filed">
              <div class="label"><span>所处地域（所在地 / 服务地）</span></div>
              <div class="van-cell van-field noBorder">
                <!-- :value=" formList.province_code.province ? province_list.find((v) => v.id / 1 === formList.province_code.province).name: '' " -->
                <van-field style="margin-right: 2vw" readonly clickable name="picker" :value="province_val" placeholder="请选择" @click="pikerShow.province_code__province = true">
                  <template #button>
                    <span style="color: rgba(102, 102, 102, 1)">省</span>
                  </template>
                </van-field>
                <!-- :value="formList.province_code.city? city_list.find((v) => v.id / 1 === formList.province_code.city ).name : ''" -->
                <van-field style="margin-right: 2vw" readonly clickable name="picker" :value="city_val" placeholder="请选择" @click="
                    formList.province_code.province &&
                      (pikerShow.province_code__city = true)
                  ">
                  <template #button>
                    <span style="color: rgba(102, 102, 102, 1)">市</span>
                  </template>
                </van-field>
                <van-field style="margin-right: 2vw" readonly clickable name="picker" :value="county_val" placeholder="请选择" @click="
                    formList.province_code.city &&
                      (pikerShow.province_code__county = true)
                  ">
                  <template #button>
                    <span style="color: rgba(102, 102, 102, 1)">区/县</span>
                  </template>
                </van-field>
                <van-popup v-model="pikerShow.province_code__province" position="bottom">
                  <van-picker value-key="name" show-toolbar :columns="province_list.slice(1)" @confirm="
                      (value) =>
                        onConfirmCity(
                          value,
                          'province_code__province',
                          'province_code__city',
                          '1'
                        )
                    " @cancel="pikerShow.province_code__province = false" />
                </van-popup>
                <van-popup v-model="pikerShow.province_code__city" position="bottom">
                  <van-picker value-key="name" show-toolbar :columns="city_list.slice(1)" @confirm="
                      (value) =>
                        onConfirmCity(value, 'province_code__city', 'province_code__county', '2')
                    " @cancel="pikerShow.province_code__city = false" />
                </van-popup>
                <van-popup v-model="pikerShow.province_code__county" position="bottom">
                  <van-picker value-key="name" show-toolbar :columns="county_list.slice(1)" @confirm="
                      (value) =>
                        onConfirmCity(value, 'province_code__county', '', '5')
                    " @cancel="pikerShow.province_code__county = false" />
                </van-popup>
              </div>
            </van-cell-group>
            <div v-if="isvolunteer">
              <div v-if="issupervise">
                <!-- 所属群团 -->
                <!-- <van-cell-group class="form_filed">
                  <div class="label"><span>所属群团</span></div>

                  <van-field v-model="formList.belongGroup" placeholder="请输入您的所属群团" type="text" maxlength="20" :rules="[
                      {
                        required: true,
                        message: '必填',
                      },
                    ]" />
                </van-cell-group> -->
                <van-cell-group class="form_filed">
                    <div class="label">
                      <span class="xinhao">*</span><span class="jianju">所属组织</span>
                    </div>

                    <van-field readonly clickable name="picker" class="input_box" :value="formList.orgKind" placeholder="请选择" @click="showPicker5 = true" :rules="[
                        {
                          required: true,
                          message: '必填',
                        },
                      ]" />
                    <van-popup v-model="showPicker5" position="bottom">
                      <van-picker show-toolbar :columns="orgKindList" @confirm="onConfirms4" @cancel="showPicker5 = false" value-key="name" />
                    </van-popup>
                  </van-cell-group>
                <van-cell-group class="form_filed" v-if="formList.orgKind === '其他'">
                  <div class="label"><span></span></div>

                  <van-field v-model="formList.otherContent" placeholder="请输入所属组织" type="text" maxlength="20" :rules="[
                      {
                        required: true,
                        message: '必填',
                      },
                    ]" />
                </van-cell-group>
              </div>
              <div>
                <!-- 工作单位 -->
                <van-cell-group class="form_filed">
                  <div class="label"><span>工作单位</span></div>

                  <van-field v-model="formList.workplace" placeholder="请输入您的具体工作单位" type="text" maxlength="20" :rules="[
                      {
                        required: true,
                        message: '必填',
                      },
                    ]" />
                </van-cell-group>
                <!-- 单位性质 -->
                <van-cell-group class="form_filed">
                  <div class="label">
                    <span class="xinhao">*</span><span class="jianju">单位性质</span>
                  </div>

                  <van-field readonly clickable name="picker" class="input_box" :value="formList.unitKind" placeholder="请选择" @click="showPicker4 = true" :rules="[
                      {
                        required: true,
                        message: '必填',
                      },
                    ]" />
                  <van-popup v-model="showPicker4" position="bottom">
                    <van-picker show-toolbar :columns="unitKindList" @confirm="onConfirms3" @cancel="showPicker4 = false" value-key="name" />
                  </van-popup>
                </van-cell-group>
                <!-- 职业 -->
                <van-cell-group class="form_filed">
                  <div class="label"><span>职业</span></div>

                  <van-field v-model="formList.career" placeholder="请输入您的职业" type="text" maxlength="20" :rules="[
                      {
                        required: true,
                        message: '必填',
                      },
                    ]" />
                </van-cell-group>
                <!-- 现任职务 -->
                <van-cell-group class="form_filed" v-if="kind != 2">
                  <div class="label"><span>现任职务</span></div>

                  <van-field v-model="formList.currentPosition" placeholder="请输入您的现任职务" maxlength="20" type="text" :rules="[{required: true,message: '必填', }]" />
                </van-cell-group>
                <!-- 学历 -->
                <van-cell-group class="form_filed">
                  <div class="label"><span>学历</span></div>

                  <van-field readonly clickable name="picker" :value="education" placeholder="请选择" @click="showPicker = true" />
                  <van-popup v-model="showPicker" position="bottom">
                    <van-picker show-toolbar :columns="columns" @confirm="onConfirms" @cancel="showPicker = false" />
                  </van-popup>
                </van-cell-group>
                <!-- 民族 -->
                <van-cell-group class="form_filed">
                  <div class="label"><span>民族</span></div>

                  <van-field readonly clickable name="picker" :value="nation_val" placeholder="请选择" @click="showPicker2 = true" />
                  <van-popup v-model="showPicker2" position="bottom">
                    <van-picker show-toolbar :columns="nationList" @confirm="onConfirms1" @cancel="showPicker2 = false" />
                  </van-popup>
                </van-cell-group>
                <!-- 籍贯 -->
                <van-cell-group class="form_filed">
                  <div class="label"><span>籍贯</span></div>
                  <div class="van-cell van-field noBorder">
                    <!-- :value="formList.native_place.province1? areaList.province_list.find( (v) => v.id / 1 === formList.native_place.province1).name : ''" -->
                    <van-field style="margin-right: 2vw" readonly clickable name="picker" :value="province1_val" placeholder="请选择" @click="pikerShow.native_place__province1 = true">
                      <template #button>
                        <span style="color: rgba(102, 102, 102, 1)">省</span>
                      </template>
                    </van-field>
                    <!-- :value=" formList.native_place.city1? areaList.city_list.find((v) => v.id / 1 === formList.native_place.city1 ).name: '' " -->
                    <van-field style="margin-right: 2vw" readonly clickable name="picker" :value="city1_val" placeholder="请选择" @click="
                        formList.native_place.province1 &&
                          (pikerShow.native_place__city1 = true)
                      ">
                      <template #button>
                        <span style="color: rgba(102, 102, 102, 1)">市</span>
                      </template>
                    </van-field>
                    <van-popup v-model="pikerShow.native_place__province1" position="bottom">
                      <van-picker value-key="name" show-toolbar :columns="areaList.province_list.slice(1)" @confirm="
                          (value) =>
                            onConfirmCity(
                              value,
                              'native_place__province1',
                              'native_place__city1',
                              '3'
                            )
                        " @cancel="pikerShow.native_place__province1 = false" />
                    </van-popup>
                    <van-popup v-model="pikerShow.native_place__city1" position="bottom">
                      <van-picker value-key="name" show-toolbar :columns="areaList.city_list" @confirm="
                          (value) =>
                            onConfirmCity(value, 'native_place__city1', '', '4')
                        " @cancel="pikerShow.native_place__city1 = false" />
                    </van-popup>
                  </div>
                </van-cell-group>
                <!-- 政治面貌 -->
                <van-cell-group class="form_filed">
                  <div class="label"><span>政治面貌</span></div>
                </van-cell-group>
                <van-field readonly clickable name="picker" :value="politicsStatus" placeholder="请选择" @click="showPicker3 = true" />
                <van-popup v-model="showPicker3" position="bottom">
                  <van-picker show-toolbar :columns="politics_status_columns" @confirm="onConfirms2" @cancel="showPicker3 = false" />
                </van-popup>
                <!-- 固定电话 -->
                <van-cell-group class="form_filed">
                  <div class="label"><span>固定电话</span></div>

                  <van-field v-model="formList.telephone" placeholder="请输入您的电话" maxlength="20" type="text" />
                </van-cell-group>
                <!-- 出生日期 -->
                <van-cell-group class="form_filed">
                  <div class="label"><span>出生日期</span></div>

                  <van-field readonly clickable name="datetimePicker" :value="formList.birthDate" placeholder="请选择" @click="showPicker1 = true" />
                  <van-popup v-model="showPicker1" position="bottom">
                    <van-datetime-picker type="date" @confirm="onConfirm1" @cancel="showPicker1 = false" :min-date="minDate" :max-date="maxDate" />
                  </van-popup>
                </van-cell-group>
              </div>
            </div>

            <!-- 提交 -->
            <div class="submit-btn">
              <van-button class="handle" round block type="info" native-type="submit"><span>提</span><span>交</span></van-button>
            </div>
          </van-form>
          <!-- 修改账号弹层 -->
          <van-popup v-model="showModifyAccountNumber" :style="{ width: '90%' }" style="padding-top: 5vw" closeable class="zhagnhaoxiugai1" @closed="closed">
            <div>
              <p style="
                  padding-left: 4vw;
                  font-weight: 700;
                  font-size: 5vw;
                  margin-bottom: 5vw;
                ">
                账号修改
              </p>

              <div style="padding: 0 3vw">
                <p style="padding-left: 4vw; padding-bottom: 3vw">
                  最多修改3次，3次后不可修改
                </p>
                <van-form @submit="onSubmit1">
                  <van-field v-model="username" name="账号" class="xiugaizhagnhao" placeholder="支持中英文、数字，不超过10个字" maxlength="10" :rules="[
                      { required: true, message: '必填' },
                      {
                        pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/,
                        message: '格式不正确',
                      },
                    ]" />
                  <div style="margin: 5vw">
                    <van-button round block type="info" native-type="submit">提交</van-button>
                  </div>
                </van-form>
              </div>
            </div>
          </van-popup>
          <!-- 修改密码弹层 -->
          <van-popup v-model="showChangePassword" :style="{ width: '90%' }" style="padding-top: 5vw" closeable @closed="closed" class="xiugaimima">
            <div style="padding-top: 0.6vw; height: 80vw">
              <div style="width: 90%; margin: auto">
                <p style="font-weight: 700; font-size: 4.6vw">修改密码</p>
              </div>
              <div style="padding: 0 4vw">
                <van-form @submit="onSubmitPassword">
                  <div style="margin-top: 10vw"></div>
                  <van-field v-model="passwordNew" :type="showPassword1" name="密码" placeholder="请输入8位密码，支持英文、数字" maxlength="8" class="iconfont icon-yuechi" :rules="[
                      { required: true, message: '必填' },
                      { pattern: /^[a-zA-Z0-9]{8}/, message: '格式不正确' },
                    ]">
                    <template #button>
                      <span class="iconfont icon-24gl-eyeHide" @click="xianshieye(1)" :class="xianshi1 && 'liangeye'"></span>
                    </template>
                  </van-field>
                  <van-field v-model="passwordNewTwo" :type="showPassword2" name="密码" placeholder="再次输入新密码" maxlength="8" class="iconfont icon-yuechi" :rules="[
                      { required: true, message: '必填' },
                      { pattern: /^[a-zA-Z0-9]{8}/, message: '格式不正确' },
                      { validator: asyncValidator, message: '密码不一致' },
                    ]">
                    <template #button>
                      <span class="iconfont icon-24gl-eyeHide" @click="xianshieye(2)" :class="xianshi2 && 'liangeye'"></span>
                    </template>
                  </van-field>
                  <div style="margin: 16px; margin-top: 10vw">
                    <van-button round block type="info" native-type="submit">提交</van-button>
                  </div>
                </van-form>
              </div>
            </div>
          </van-popup>
        </div>
        <!-- 邀请码弹框 -->
        <van-dialog v-model="InvitationCode" title="邀请码" show-cancel-button clickable @confirm="queren(querenState)" @cancel="quxiao">
          <van-field v-model="Invitation" placeholder="邀请码" />
        </van-dialog>
        <!-- 我的举报 -->
        <!-- <div>
          <div class="title">
            <div class="text">我的举报</div>
            <div class="line" />
          </div>
          <div v-if="jubaoxinxishen.length">
            <van-pagination v-model="currentPage" :page-count="pageNum" @change="handleCurrentChange" mode="simple" :total-items="total">
              <template #prev-text>
                <van-icon name="arrow-left" />
              </template>
              <template #next-text>
                <van-icon name="arrow" />
              </template>
            </van-pagination>
            <div class="biaoge">
              <div class="biaoge_title">
                <div v-for="(item, index) in jubaoxinxitou" :key="index">
                  <div class="biaoge_title_title" :class="item.title == '查看' && 'biaoge_title_title_last'"><span>{{item.title}}</span></div>
                </div>
              </div>
              <div class="biaoge_content">
                <div v-for="(item, index) in jubaoxinxishen" :key="index">
                  <div class="biaoge_content_content"><span>{{item.damageKindName}}</span></div>
                  <div class="biaoge_content_content"><span>{{item.damageSubKindName}}</span></div>
                  <div class="biaoge_content_content"><span>{{reportedPlatformMap[item.reportedPlatform]}}</span></div>
                  <div class="biaoge_content_content"><span>{{timeFilter(item.createTime)}}</span></div>
                  <div class="biaoge_content_content" @mousedown="chufa(item.content)"><span>{{item.content}}</span></div>
                  <div>
                    <div class="biaoge_content_content">
                      <span :style="`color:${
                          item.status != 3 ? '#EA5F00' : '#7CB305'
                        }`">●</span>
                      <span style="
                          color: #646566;
                          font-size: 12px;
                          line-height: 1.5;
                          word-break: break-all;
                        ">
                        {{item.subStatus == 3 ? '人工判定无效': statusMap[item.status] }}
                      </span>
                    </div>
                  </div>
                  <div @click="chankanhuifu(item.id)" class="huifucolor biaoge_content_content biaoge_content_content_last">
                    查看回复 ></div>
                </div>
              </div>
            </div>
          </div>
          <div v-else style="text-align: center; font-size: 4vw; font-weight: 700;margin-top:5vw">
            暂无举报
          </div>
          <van-popup v-model="isShow" closeable close-icon="cross" class="popup-huifu" style="max-height: 90%;min-width:60%">
            <div>
              <div class="huifu-title">
                <h3 class="huifu-title_h3">举报回复</h3>
              </div>
              <div class="huifu-content">
                <div v-if="lists.length !== 0">
                  <div v-for="(item, index) in lists" :key="index">
                    <div class="huifu-content_pic"> <img :src="require('../../assets/img/成功@3x.png')" alt="" style="width: 5.33vw;height: 5.33vw;">
                      {{item.replyValue || item.content}}</div>
                    <div class="huifu-content-color"> <span>{{ item.orgName }}</span><span>{{&nbsp;}}</span> <span class="name_jianju">{{ item.username }}</span>
                      <span>{{
                  item.createTime ? time_sFilter(item.createTime) : ""
                }}</span>
                    </div>
                    <div class="Underline_huifu"></div>
                  </div>
                </div>
                <div v-if="lists.length == 0" class="meiyoushuju">
                  <img src="../../assets/img/举报失败.png" alt="" style="width: 30vw; height: 30vw" />

                </div>
              </div>
            </div>
          </van-popup>
        </div> -->
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { areaLists } from '@/utils/areaLists.js'
import moment from 'moment'
import { encrypt } from '@/utils/security'

export default {
  name: '',
  props: {},
  data () {
    return {
      authenticationKind: '',
      accountUpdatable: '',
      kind: '',
      formListStatus: '',
      token: '',
      id: '',
      pikerShow: {
        province_code__province: false,
        province_code__city: false,
        province_code__county: false,
        native_place__province1: false,
        native_place__city1: false
      },
      showPassword1: 'password',
      showPassword2: 'password',
      xianshi1: false,
      xianshi2: false,
      Invitation: '',
      InvitationCode: false,
      querenState: '',
      provinceNum: '',
      nativeProvinceNum: '',
      county_list: [],
      city_list: [],
      province_list: [],
      updateShow: false,
      statusMap: {
        0: '待初审',
        1: '待受理',
        2: '待处置',
        3: '已处置'
      },
      reportedPlatformMap: {
        0: '网站网页',
        1: 'APP',
        2: '网络账号'
      },
      pageNum: 2,
      pageSize: '1',
      page: '1',
      total: 0,
      currentPage: 1,
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(2100, 11, 30),
      currentDate: new Date(2021, 0, 17),
      username: '', // 修改账号
      passwordNew: '', // 新密码
      passwordNewTwo: '', // 确认新密码
      native_place: '',
      province_code: '',
      formList: {
        avatar: '', // 头像
        username: '', // 账号
        password: '123123', // 密码
        nickname: '', // 确认密码
        name: '', // 姓名
        phone: '', // 手机号
        wodeshenfen: '网民', // 身份
        gender: '0', // 性别
        email: '', // 电子邮箱
        province_code: { province: '', city: '',county:'' }, // 所处区域
        belongGroup: '', // 所属群团
        workplace: '', // 工作单位
        career: '', // 职业
        currentPosition: '', // 现任职务
        education: '', // 学历
        nation: '', // 民族
        native_place: { province1: '', city1: '' }, // 籍贯
        politicsStatus: '', // 政治面貌
        idCard: '', // 身份证号
        telephone: '', // 固定电话
        birthDate: '', // 出生日期
        zip_code: '', // 邮编
        nativeProvince: '',
        nativeCity: '',
        unitKind:'',
        orgKind:'',
        otherContent:''
      },
      nation: '', // 民族
      education: '', // 学历
      politicsStatus: '', // 政治面貌
      value: '',
      areaLists,
      showArea: false,
      showArea3: false,
      isShow: false,
      number_page: 4,
      perpage: 2,
      isvolunteer: false,
      issupervise: true,
      showModifyAccountNumber: false,
      showChangePassword: false,
      showPicker: false,
      showPicker1: false,
      showPicker2: false,
      showPicker3: false,
      showPicker4: false,
      showPicker5: false,
      columns: [
        '本科',
        '专科',
        '研究生',
        '博士生',
        '高中',
        '初中',
        '小学',
        '其他'
      ],
      nationList: [],
      politics_status_columns: ['群众', '共产党员', '共青团员', '民主党派'],
      jubaoxinxitou: [
        { title: '举报类型' },
        { title: '危害小类' },
        { title: '被举报平台' },
        { title: '举报时间' },
        { title: '举报内容' },
        { title: '举报进度' },
        { title: '查看' }
      ],
      jubaoxinxishen: [],
      jubaoxinxishenlist: [],
      lists: [],
      educationList: [
        { education: '本科', status: '1' },
        { education: '专科', status: '2' },
        { education: '研究生', status: '3' },
        { education: '博士生', status: '4' },
        { education: '高中', status: '5' },
        { education: '初中', status: '6' },
        { education: '小学', status: '7' },
        { education: '其他', status: '8' }
      ],
      politicsStatusList: [
        {
          name: '群众',
          value: 0
        },
        {
          name: '共产党员',
          value: 1
        },
        {
          name: '共青团员',
          value: 2
        },
        {
          name: '民主党派',
          value: 3
        }
      ],
      areaList: {
        city_list: [],
        province_list: []
      },
      oldForm: {
        kind: ''
      },
      unitKindList:[],
      orgKindList:[],
    }
  },
  created () {
    this.init()
    this.getMyReport()
  },
  methods: {
    init () {
      this.setShowLoading(false)
      // 用户是否登录
      const token =
        localStorage.getItem('userInfo') &&
        JSON.parse(localStorage.getItem('userInfo')) &&
        JSON.parse(localStorage.getItem('userInfo')).token
      if (token) {
        this.token = token
        // 显示登陆头像
        this.setActiveName(true)
      } else {
        this.setActiveName(false)
        this.$router.push('/')
      }
      // areaList市区联动查询
      this.$Api.areaList({ type: '1', parentId: '1' }).then((res) => {
        this.province_list = res.list
        this.areaList.province_list = res.list
      })
      // 民族信息
      this.$Api.dictionaryList({ type: '2' }).then((res) => {
        this.nationList = res.list.map((res) => res.key)
        this.nationLists = res.list
      })
      // 举报是否通过,传状态 如果不通过传不通过理由给认证页面
      this.$Api.getIdentify({}, { noToast: true }).then(res => {
        this.oldForm = res
      })
      this.getUnitKindList()
      this.getOrgKindList()
      this.userinfo()
    },
    ...mapMutations(['setShowLoading', 'setActiveName', 'setMaterialsStatus']),
    // 请求用户信息
    userinfo () {
      this.$Api
        .userGet({}, { noToast: true })
        .then((res) => {
          if (res) {
            setTimeout(() => {
              this.accountUpdatable = res.accountUpdatable
              this.formListStatus = res.status
              this.kind = res.kind
              this.id = res.id
              this.formList.avatar = res.avatar
              this.formList.username = res.username
              this.formList.name = res.name
              this.formList.nickname = res.nickname
              this.formList.phone = res.phone
              this.formList.gender = JSON.stringify(res.gender)
              this.formList.email = res.email
              this.formList.province_code.province = res.provinceCode
              this.provinceNum = res.provinceCode
              this.formList.province_code.city = res.cityCode
              this.formList.province_code.county = res.countyCode
              if (res.kind == 1) {
                this.formList.wodeshenfen = '网民'
              }
              if (res.kind == 1) {
                this.formList.wodeshenfen = '义务监督员'
                this.isvolunteer = true
                this.issupervise = false
              }
              if (res.kind == 2) {
                this.formList.wodeshenfen = '志愿者'
                this.isvolunteer = true
                this.formList.belongGroup = res.belongGroup // 群团
              }
              this.formList.native_place.city1 = res.nativeCity
              this.formList.native_place.province1 = res.nativeProvince
              this.nativeProvinceNum = res.nativeProvince
              this.formList.zip_code = res.zipCode
              this.formList.birthDate = this.timeFilter(res.birthDate)
              this.formList.telephone = res.telephone
              this.formList.idCard = res.idCard
              this.formList.currentPosition = res.currentPosition //
              this.formList.career = res.career // 职业
              this.formList.workplace = res.workplace // 工作单位
              // 学历
              const educationVal = this.educationList.filter(r => r.status == res.education)[0] && this.educationList.filter(r => r.status == res.education)// 学历
              this.education = educationVal && educationVal[0] && educationVal[0].education
              // 民族
              // const nationVal = this.nationLists.filter(r => r.id == res.nation)
              // this.nation = nationVal && nationVal[0] && nationVal[0].key
              this.nation = res.nation
              this.formList.nation = res.nation
              // 政治面貌
              const politicsVal = this.politicsStatusList.filter(r => r.value == res.politicsStatus)
              this.politicsStatus = politicsVal && politicsVal[0] && politicsVal[0].name
              this.formList.unitKind = res.unitName
              this.formList.orgKind = res.orgName
              this.formList.otherContent = res.otherContent
            }, 500)
          }
        })
        .catch(() => {

        })
    },
    getUnitKindList(){
        this.$Api.getUnitKindList().then((res) => {
          this.unitKindList = res
        })
    },
    getOrgKindList(){
        this.$Api.getOrgKindList().then((res) => {
          this.orgKindList = res
        })
    },
    handleCurrentChange (page) {
      // 切换页数
      this.getMyReport(page)
    },
    getMyReport (page) {
      const params = {
        page,
        pageSize: 1
      }
      this.$Api
        .reportQueryReport(params)
        .then((res) => {
          if (res.list) {
            const arr = res.list
            this.pageNum = res.total
            this.jubaoxinxishen = arr
            this.show = true
          } else {
            this.showshibai = true
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 格式化时间
    timeFilter (time) {
      return moment(time).format('YYYY-MM-DD')
    },
    // 格式化时间
    time_sFilter (time) {
      return moment(time).format('YYYY-MM-DD HH:mm')
    },
    onConfirms (value) {
      this.education = value
      this.showPicker = false
    },
    // 民族
    onConfirms1 (value) {
      this.nation = value
      const arrNation = this.nationLists.filter(res => res.key == this.nation)
      this.formList.nation = arrNation && arrNation[0] && arrNation[0].id

      this.showPicker2 = false
    },
    onConfirms2 (value) {
      this.politicsStatus = value
      this.showPicker3 = false
    },
    onConfirms3 (value) {
      this.formList.unitKind = value.name
      this.showPicker4 = false
    },
    onConfirms4 (value) {
      this.formList.orgKind = value.name
      this.showPicker5 = false
    },
    onConfirm1 (value) {
      this.formList.birthDate = moment(value).format('YYYY-MM-DD')
      this.showPicker1 = false
    },
    onSubmit () {
      this.$refs.formRef.validate()
      let params = {...this.formList}

      params.provinceCode = this.formList.province_code.province
      params.cityCode = this.formList.province_code.city
      params.countyCode = this.formList.province_code.county
      const arrPolitics = this.politicsStatusList.filter(res => res.name == this.politicsStatus)
      params.politicsStatus = arrPolitics && arrPolitics[0] && arrPolitics[0].value
      const arrEducation = this.educationList.filter(res => res.education == this.education)
      params.education = arrEducation && arrEducation[0] && arrEducation[0].status
      params.nativeProvince = this.formList.native_place.province1
      params.nativeCity = this.formList.native_place.city1
      let unitKindItem = this.unitKindList.find(item => item.name == this.formList.unitKind)
      params.unitKind = unitKindItem ? unitKindItem.type :''
      let orgKindItem = this.orgKindList.find(item => item.name == this.formList.orgKind)
      params.orgKind = orgKindItem ? orgKindItem.type :''
      // 用户修改
      this.$Api
        .userUpdate(params)
        .then((res, status) => {
          this.$dialog.alert({
            title: '提示',
            message: '修改成功'
          })
        })
        .catch((err) => {
          console.log(err)
          this.$dialog
            .alert({
              title: '标题',
              message: '修改失败！'
            })
            .then(() => {
              // on close
              // 刷新页面
              this.init()
            })
        })
    },
    chankanhuifu (id) {
      this.isShow = true
      //
      this.$Api.reportQueryReportReply({ reportId: id }).then(res => {
        this.lists = res
        // if (res.length == 0) retur
      }).catch(err => { console.log(err) })
    },

    toAuthentication () {
      if (this.kind === 0 && (this.formListStatus === 0 || this.formListStatus === 2) && this.oldForm.kind == 1) {
        this.$router.push({
          path: '/authentication',
          query: {
            isVolunteerCertification: 1
          }
        })
      } else {
        this.InvitationCode = true
        this.querenState = 1
      }
    },
    toVolunteerCertification () {
      if (this.kind === 0 && (this.formListStatus === 0 || this.formListStatus === 2) && this.oldForm.kind == 2) {
        this.$router.push({
          path: '/authentication',
          query: {
            isVolunteerCertification: 2
          }
        })
      } else {
        this.InvitationCode = true
        this.querenState = 2
      }
    },
    ModifyAccountNumber () {
      this.showModifyAccountNumber = true
    },
    ChangePassword () {
      this.showChangePassword = true
    },
    // 修改密码
    onSubmitPassword () {
      // 提交
      const password = encrypt(this.passwordNew)
      const passwordVerify = encrypt(this.passwordNewTwo)
      this.$Api
        .userResetPwd({ password, passwordVerify })
        .then((res) => {
          // 成功修改
          this.$dialog
            .alert({
              title: '标题',
              message: '修改成功！'
            })
            .then(() => {
              // on close
              this.passwordNew = ''
              this.passwordNewTwo = ''
              // 关闭弹层
              this.showChangePassword = false
              // 刷新页面
              this.init()
            })
        })
        .catch((err) => {
          this.$dialog
            .alert({
              title: '标题',
              message: '修改失败！'
            })
            .then(() => {
              // on close
              this.passwordNew = ''
              this.passwordNewTwo = ''
              // 关闭弹层
              this.showChangePassword = false
              // 刷新页面
              this.init()
            }).catch(err)
        })
    },
    onSubmit1 () {
      // 提交
      this.$Api
        .userResetUsername({ username: this.username })
        .then((res) => {
          // 成功修改
          this.$dialog
            .alert({
              title: '标题',
              message: '修改成功！'
            })
            .then(() => {
              // on close
              this.showModifyAccountNumber = false
              this.username = ''
              // 刷新页面
              this.init()
            })
        })
        .catch((err) => {
          console.log(err)
          // 修改失败
          this.$dialog
            .alert({
              title: '标题',
              message: '修改失败！'
            })
            .then(() => {
              // on close
              this.showModifyAccountNumber = false
              this.username = ''

              // 刷新页面
              this.init()
            })
        })
    },
    asyncValidator (val) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(this.passwordNew == this.passwordNewTwo)
        }, 0)
      })
    },
    quxiao () {
      this.$router.push('/personal')
      this.Invitation = ''
    },
    queren (state) {
      // 判断邀请码是否正确

      this.$Api.inviteCheck({
        inviteCode: encrypt(this.Invitation),
        inviteType: state
      }, {
        callback: (res) => {
          if (res.status !== 0) {
            this.$dialog.confirm({
              title: '提示',
              message: res.message
            })
            this.Invitation = ''
          }
        },
        noToast: true
      }).then(() => {
        this.$router.push({
          path: '/authentication',
          query: {
            isVolunteerCertification: state,
            inviteCode: encrypt(this.Invitation)
          }
        })
      }).catch()
    },
    xianshieye (i) {
      if (i == 1) {
        this.xianshi1 = !this.xianshi1

        if (this.xianshi1 == true) {
          this.showPassword1 = 'type'
        } else {
          this.showPassword1 = 'password'
        }
      } else if (i == 2) {
        this.xianshi2 = !this.xianshi2
        if (this.xianshi2 == true) {
          this.showPassword2 = 'type'
        } else {
          this.showPassword2 = 'password'
        }
      }
    },
    closed () {
      this.username = ''
      this.passwordNew = ''
      this.passwordNewTwo = ''
    },
    onConfirmCity (value, filed, clearFiled, type) {
      this.pikerShow[filed] = false
      this.formList[filed.split('__')[0]][filed.split('__')[1]] = value.id
      if (clearFiled) {
        this.formList[clearFiled.split('__')[0]][clearFiled.split('__')[1]] =
          ''
      }
      if (type === '1' || type === '3') {
        type === '1' && (this.formList.province_code.county = '')
        type === '3' && (this.areaList.city_list = [])
        this.$Api.areaList({ type: '2', parentId: value.id }).then((res) => {
          type === '1' && (this.city_list = res.list)
          type === '3' && (this.areaList.city_list = res.list)
        })
      }else if(type === '2'){
        this.$Api.areaList({ type: '3', parentId: value.id }).then((res) => {
          this.county_list = res.list
        })
      }
    },
    chufa (content) {
      this.$toast({
        duration: 5000, // 持续展示 toast
        // forbidClick: true,
        message: content
      })
    }

  },
  computed: {
    ...mapState(['ActiveName']),
    province_val () {
      const val = this.formList.province_code.province ? this.province_list.find((v) => v.id / 1 === this.formList.province_code.province) : ''
      const vals = val && val.name
      return vals
    },
    city_val () {
      const val = this.formList.province_code.city ? this.city_list.find((v) => v.id / 1 === this.formList.province_code.city) : ''
      const vals = val && val.name
      return vals
    },
    county_val () {
      const val = this.formList.province_code.county ? this.county_list.find((v) => v.id / 1 === this.formList.province_code.county) : ''
      const vals = val && val.name
      return vals
    },
    // 籍贯
    province1_val () {
      const val = this.formList.native_place.province1 ? this.areaList.province_list.find((v) => v.id / 1 === this.formList.native_place.province1) : ''
      const vals = val && val.name
      return vals
    },
    city1_val () {
      const val = this.formList.native_place.city1 ? this.areaList.city_list.find((v) => v.id / 1 === this.formList.native_place.city1) : ''
      const vals = val && val.name
      return vals
    },
    nation_val () {
      let nationVal = this.nationLists.find(r => r.id == this.formList.nation)
      nationVal = nationVal && nationVal.key
      return nationVal
    }

  },
  watch: {
    province_val () {
      this.$Api
        .areaList({
          type: '2',
          parentId: this.formList.province_code.province
        })
        .then((res) => {
          this.city_list = res.list
        })
    },
    city_val () {
      this.$Api
        .areaList({
          type: '3',
          parentId: this.formList.province_code.city
        })
        .then((res) => {
          this.county_list = res.list
        })
    },
    province1_val () {
      this.$Api
        .areaList({
          type: '2',
          parentId: this.formList.native_place.province1
        })
        .then((res) => {
          this.areaList.city_list = res.list
        })
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
.personal_info {
  margin-top: 0.8vw;
  font-size: 3.73vw;
  .van-cell__title,
  .van-cell__value {
    flex: none !important;
  }
  .user_img {
    display: flex;
    justify-content: center;
    ::v-deep img {
      width: 17.06666vw;
      height: 17.06666vw;
    }
  }
  .form_filed_handle {
    color: #002fa7;
  }
  .sexSelectBox {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 3.73vw;
    width: 29.3vw;
    height: 10.67vw;
    background: #f6f8fa;
    color: rgba(0, 0, 0, 0.85);
    margin-right: 4vw;
  }
  .sexSelected {
    font-weight: bold;
    color: #002fa7;
    background: #e9f1ff;
  }
  .lineTwoSelect {
    width: 38.6vw;
    height: 10.67vw;
    border: 2px solid rgba(0, 0, 0, 0.15);
  }
  .submit-btn {
    display: flex;
    justify-content: center;
    margin-top: 10.67vw;
    .handle {
      height: 10.67vw;
      display: flex;
      justify-content: center;
      width: 80vw;
      background: rgba(0, 47, 167, 1);
      font-weight: bold;
      span {
        margin: 0 1vw;
        font-size: 4.2vw;
      }
    }
  }
  ::v-deep.van-field__control:disabled {
    -webkit-text-fill-color: #000;
  }
}

.PersonalCenter-center {
  box-sizing: border-box;
  padding: 3vw;
  font-size: 4vw;
}

tr {
  &:first-child td {
    border-top: 0.5vw solid #000;
  }
  td {
    padding: 0.5vw;
    border-right: 0.5vw solid #000;
    border-bottom: 0.5vw solid #000;
    &:nth-child(1) {
      border-left: 0.5vw solid #000;
    }
    &:last-child {
      border-right: 0.5vw solid #000;
    }
  }
}
.biaoge {
  display: flex;
  align-items: center;
  justify-content: center;
}

.van-field__error-message {
  font-size: 3vw;
}
.xingbieanniu {
  width: 25vw;
  height: 9vw;
  text-align: center;
  line-height: 9vw;
  background: #f6f8fa;
  margin: 0vw 2vw;
}
.xingbieanniudianji {
  font-weight: bold;
  color: #002fa7;
  background: #e9f1ff;
  border: 1px solid #002fa7;
}
.authentication {
  color: #002fa7;
  display: flex;
  justify-content: space-between;
  font-size: 3.7vw;
  padding: 4vw 3vw 1.3vw 3vw;
}
.liangeye {
  font-weight: 700;
  color: #002fa7;
}
.change-btn {
  color: #002fa7;
  border: none;
}
.meiyoushuju {
  text-align: center;
  margin-bottom: 7vw;
}
.huifu-title_h3 {
  margin: 3vw 0 3vw 3vw;
}
.PersonalCenter {
  .title {
    margin-top: 5vw;
  }
}
.xiugaimima {
  .van-cell {
    border-bottom: 0.3vw solid #d0d0d0;
  }
}
</style>
